import { motion } from "framer-motion"
import { Card } from "components/Card/Card"
import { useLangContext } from "context/Lang"

export function Features() {

    const { gW } = useLangContext()

    const features = [
        {
            key: "immersive-learning",
            icon: "🥽",
        },
        {
            key: "global-collaboration",
            icon: "🌐",
        },
        {
            key: "interactive-content",
            icon: "🔬",
        },
        {
            key: "progress-tracking",
            icon: "📊",
        },
        {
            key: "ai-powered-tutoring",
            icon: "🤖",
        },
        {
            key: "cross-platform",
            icon: "📱",
        },
    ]

    return (
        <section id="features" className="py-20 md:py-32">
            <div className="container mx-auto px-6">
                
                {/* Title */}
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6 }}
                    className="mb-16 text-center"
                >
                    <h2 className="mb-4 text-balance text-4xl font-bold md:text-5xl text-primary-900">
                        {gW("revolutionary-learning-features")}
                    </h2>

                    <p className="mx-auto max-w-2xl text-balance text-lg text-primary-700">
                        {gW("revolutionary-learning-features-desc")}
                    </p>
                </motion.div>

                {/* Cards */}
                <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
                    {features.map((feature, index) => (
                        <motion.div
                            key={feature.key}
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.5, delay: index * 0.1 }}
                        >
                            <Card className="group relative overflow-hidden p-6 transition-all hover:shadow-lg border-primary-600/20">
                                <motion.div
                                    className="absolute inset-0 bg-primary-600/10"
                                    initial={{ x: "-100%" }}
                                    whileHover={{ x: 0 }}
                                    transition={{ duration: 0.3 }}
                                />

                                <div className="relative">
                                    <div className="mb-4 text-4xl">{feature.icon}</div>

                                    <h3 className="mb-2 text-xl font-semibold text-primary-900">
                                        {gW(`${feature.key}-title`)}
                                    </h3>

                                    <p className="text-sm leading-relaxed text-primary-700">
                                        {gW(`${feature.key}-desc`)}
                                    </p>
                                </div>
                            </Card>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    )
}